import { render, staticRenderFns } from "./RecursoNaturalParaguai.vue?vue&type=template&id=78a9c2bd&lang=pug"
import script from "./RecursoNaturalParaguai.vue?vue&type=script&lang=js"
export * from "./RecursoNaturalParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports